import { isString, some } from 'lodash';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import env from '@/env';
import store from '@/store';

const TAX_INFO_STATUS_CODE = 403;
const TAX_INFO_MESSAGE_CODE = 'requireTax1099Redirect';

const DOCUMENT_UPLOAD_SKIP_POPUP_URLS = [
  'Wallet/DepositCard',
  'Wallet/ConfirmDepositCard',
  'Wallet/SubmitDepositCard',
  'Wallet/WithdrawAch',
  'Wallet/WithdrawCheck',
  'Wallet/DepositUSDCoin',
  'Wallet/WithdrawWire',
  'Wallet/WithdrawUSDC',
  'Wallet/DepositPWMB',
];

export function checkResponseForMaintenance(response) {
  const maintenanceMessage = response.headers['pi-maintenancemessage'];
  const suspendedMessage = response.headers['pi-tradingsuspendedmessage'];
  const systemMessage = response.headers['pi-systemmessages'];

  store.dispatch('app/setMaintenance', {
    isMaintenanceEnabled: typeof maintenanceMessage !== 'undefined',
    isTradingEnabled: typeof maintenanceMessage === 'undefined',
    maintenanceMessage: maintenanceMessage || '',
    suspendedMessage: suspendedMessage || '',
    systemMessage: systemMessage || '',
  });
}

export function checkResponseForTaxInfo(response) {
  if (
    !(
      response.status === TAX_INFO_STATUS_CODE &&
      response.data.code &&
      response.data.code === TAX_INFO_MESSAGE_CODE
    )
  )
    return;
  setTimeout(() => {
    store.dispatch('popup/setCurrentPopup', MODALS.TAX_INFO);
  }, 1000);
}

export function checkResponseForDocumentUpload(response) {
  const dontAct =
    response.config.method.toLowerCase() === 'get' &&
    some(DOCUMENT_UPLOAD_SKIP_POPUP_URLS, (x) => response.config.url.includes(x));

  if (!(response.data.duRequired || response.data.duPending) || dontAct) return;

  store.dispatch('popup/setCurrentPopup', MODALS.UPLOAD_DOCUMENT);
  store.dispatch('popup/setCurrentPopupOptions', {
    isPending: !!response.data.duPending,
    source: response.data.duSource,
  });
}

export function checkResponseForApiGoingOffline(response) {
  if (!(response.data && isString(response.data) && response.data.includes('MaintenanceMessage')))
    return;
  // When error response includes MaintenanceMessage redirect to home
  // This situation means API is offline
  window.location.href = env.ROOT_PATH;
}

export function checkResponseVersion(response) {
  const version = response.headers['x-version'];
  if (!version) return;
  if (store.state.app.initialVersion === null) {
    store.dispatch('app/setInitialVersion', version);
    store.dispatch('app/setServerVersion', version);
    return;
  }
  store.dispatch('app/confirmServerVersion', version);
}

export default {
  checkResponseForMaintenance,
  checkResponseForTaxInfo,
  checkResponseForApiGoingOffline,
  checkResponseVersion,
};
